export function validateLength(
  maxLength: number,
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error =
    value.length <= maxLength
      ? []
      : [`${name}は${maxLength}文字以内で入力してください。`];
  callback?.(error);
  return error;
}

export function validateKatakana(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error =
    value.match(/^[\u30A1-\u30F6\u30fb\u30fc]+$/) != null
      ? []
      : [`${name}は全角カタカナで入力してください。`];
  callback?.(error);
  return error;
}

export function validateRequired(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error =
    value.length > 0 ? [] : [`${name}は必須です。入力してください。`];
  callback?.(error);
  return error;
}

/**
 * 以下のいずれかに該当する入力を拒否する。
 * - 不可視文字 (制御文字 Cc / フォーマット文字 Cf) が1文字でも含まれる
 *   （例: ゼロ幅スペース U+200B、ZWJ/ZWNJ、BOM、双方向制御文字 等）
 * - 文字列全体が空白類 (Zs/Zl/Zp: 半角・全角スペース、NO-BREAK SPACE 等) のみで構成されている
 *
 * 必須チェックは validateRequired に任せるため、空文字はここでは通す。
 */
export function validateInvisibleOrWhitespaceOnly(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  let error: string[] = [];
  if (value.length > 0) {
    if (/[\p{Cf}\p{Cc}]/u.test(value)) {
      error = [`${name}に使用できない文字が含まれています。`];
    } else if (/^[\p{Zs}\p{Zl}\p{Zp}]+$/u.test(value)) {
      error = [`${name}は空白のみでは入力できません。`];
    }
  }
  callback?.(error);
  return error;
}

export function validateLastName(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error = [
    ...validateRequired(name, value),
    ...validateLength(256, name, value),
    ...validateInvisibleOrWhitespaceOnly(name, value),
  ];
  callback?.(error);
  return error;
}

export function validateFirstName(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error = [
    ...validateRequired(name, value),
    ...validateLength(256, name, value),
    ...validateInvisibleOrWhitespaceOnly(name, value),
  ];
  callback?.(error);
  return error;
}

export function validateLastNameKana(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error = [
    ...validateRequired(name, value),
    ...validateLength(256, name, value),
    ...validateInvisibleOrWhitespaceOnly(name, value),
    ...validateKatakana(name, value),
  ];
  callback?.(error);
  return error;
}

export function validateFirstNameKana(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error = [
    ...validateRequired(name, value),
    ...validateLength(256, name, value),
    ...validateInvisibleOrWhitespaceOnly(name, value),
    ...validateKatakana(name, value),
  ];
  callback?.(error);
  return error;
}

export function validateEmployeeNo(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error = [
    ...validateRequired(name, value),
    ...validateLength(256, name, value),
    ...validateInvisibleOrWhitespaceOnly(name, value),
  ];
  callback?.(error);
  return error;
}

export function validateInsuranceSymbol(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error = [
    ...validateRequired(name, value),
    ...validateLength(32, name, value),
    ...validateInvisibleOrWhitespaceOnly(name, value),
  ];
  callback?.(error);
  return error;
}

export function validateInsuranceNumber(
  name: string,
  value: string,
  callback?: (error: string[]) => void
) {
  const error = [
    ...validateRequired(name, value),
    ...validateLength(32, name, value),
    ...validateInvisibleOrWhitespaceOnly(name, value),
  ];
  callback?.(error);
  return error;
}
